
export default {
  name: 'Description',
  computed: {
    airportName() {
      return this.$store.state.airport.name || '';
    },
    airportCountry() {
      return this.$store.state.airport.country.name || '';
    },
    instructionLinks() {
      const links = [];
      if (this.$store.state.route.merchantContent?.how_to_park) {
        const type = this.$store.state.route.parkingService?.price_type || null;
        const parkingType = type ? this.$i18n(`reservation.${type}`) : '-';
        links.push({
          title: `${parkingType} ${this.$i18n('general.parking').toLowerCase()}`,
          id: 'parking-content',
        });
      }
      if (this.$store.state.airportRouteContent?.content) {
        links.push({
          title: this.$i18n('customer.traffic-information'),
          id: 'traffic-information',
        });
      }
      return links;
    },
  },
  methods: {
    openInstruction(key) {
      this.$nuxt.$emit('open-instruction', { key, forceOpen: true });
    },
  },
};
